import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import Link from "@mui/material/Link";
import type { MouseEvent } from "react";
import { Link as RouterLink } from "react-router";
import { proposalComparisonPath } from "work/proposals/comparison/proposal-comparison";

/**
 * Opens the side-by-side comparison of one request's proposals (#581). Shown only where the group
 * holds more than one proposal; a group of one has nothing to compare.
 */
export default function ProposalComparisonLink(
  props: Readonly<{ rfpId: string; proposalCount: number | undefined }>,
) {
  const { rfpId, proposalCount } = props;
  if (!proposalCount || proposalCount < 2) return null;

  // The row underneath opens the proposal. Letting both fire would open it over the comparison.
  function handleClick(event: MouseEvent) {
    event.stopPropagation();
  }

  return (
    <Link
      component={RouterLink}
      to={proposalComparisonPath(rfpId)}
      onClick={handleClick}
      variant="body2"
      sx={{ alignItems: "center", alignSelf: "flex-start", display: "inline-flex", gap: 0.5, whiteSpace: "nowrap" }}
    >
      <CompareArrowsIcon fontSize="inherit" aria-hidden />
      Compare {proposalCount} proposals
    </Link>
  );
}
